<template>
  <div class="user-icon-name">
    <span :class="[ className, 'userimg' ]">
      <img v-if="userInfo.userIcon" :src="userInfo.userIcon" alt="image" class="img-circle">
      <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
    </span>
    <div :class="[ className, 'userinfo' ]">
      <span class="search-username">{{userInfo.userName}}</span>
      <span class="search-userdept">{{userInfo.dept}}</span>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'UserIconName',
  // props: ['userIcon', 'userName', 'userDept', 'userFeeling', 'userEmail', 'userPhone', 'careerSummary', 'userBio', 'rUserBio', 'edit', 'vName'],
  props: {
    userId: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: 'search'
    }
  },
  data: function () {
    return {
      userInfo: {}
    }
  },
  computed: {
    ...mapGetters('users/', [
      'getUserInfoById'
    ])
  },
  mounted: function () {
    this.userInfo = this.getUserInfoById(this.userId)
    console.log('userIconName:', this.userId, this.userInfor)
  },
  methods: {
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/User/UserIconName.vue